import { render, staticRenderFns } from "./TreeBreadcrumb.vue?vue&type=template&id=352ef525&scoped=true&"
import script from "./TreeBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TreeBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./TreeBreadcrumb.vue?vue&type=style&index=0&id=352ef525&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ef525",
  null
  
)

export default component.exports